$( document ).ready(function() {

 load_more_products();
  
  var divElement = document.getElementById("buy_as_set");
  var divWithClass = divElement?.querySelector(".prod_content");

  if (divWithClass.innerHTML.trim() === "") {
  } else {
    divElement.classList.remove("d-none")
  }

  if($(".section-complete_the_look .product-list__inner .product-item").length){
    
    $(".complete_the_look").removeClass("d-none")
  }

  function waitForElementToRender(elementId) {
  return new Promise((resolve) => {
    const observer = new MutationObserver((mutationsList, observer) => {
      const element = document.getElementById(elementId);
      if (element) {
        observer.disconnect(); // Stop observing mutations
        resolve(element);
      }
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  });
}

async function doSomethingAfterElementRendered() {
  const targetElement = await waitForElementToRender('BIS_trigger');
  $(targetElement).clone();
  $(targetElement).addClass("button")

  $(".product-form__payment-container").append(targetElement)
  //console.log('Target element is rendered:', targetElement);
}

doSomethingAfterElementRendered();

  

  $(".set_product .block-swatch__radio").each(function(){
    if($(this).attr("checked")){
      $(this).click();
      return;
    }
  })
    
  $(".main_product .block-swatch__radio").click(function(){
    $(".main_product .block-swatch__radio").removeAttr("checked")
    $(this).attr("checked", "checked");
  })

  $(".set_product .block-swatch__radio").click(function(){
    $(".set_product .block-swatch__radio").removeAttr("checked")
    $(this).attr("checked", "checked");
  })

    
  $('.add-to-cart-button').click(function() {

    var main_prod_id = $(".main_product .block-swatch input:checked").attr("data-v-id");
    var set_prod_id = $(".set_product .block-swatch input:checked").attr("data-v-id");

    var itemsData = [
      {
        id: main_prod_id,
        quantity: 1
      },
      {
        id: set_prod_id,
        quantity: 1
      }
    ];

    var data = {
      items: itemsData
    };

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function(response) {
        console.log('Product added to cart successfully!');
        console.log(response);
      },
      error: function(xhr, status, error) {
        console.error('Error adding product to cart:', error);
      }
    });

  });
  

  if($(".shopify-section--main-customers-account").length > 0){

    $(".order_tracking").click(function(){
      var order_id = $(this).attr("data-orderId");
      var btn_ = $(this)
      $.get(ENDPOINT,{ action: "accounts_tracking", store: 6, id: order_id })
        .done(function(data){
          var response = JSON.parse(data);

          if(response.status == 0){
            var popup = `<div class="no_tracking"><label>Encomenda em processo de preparação</label></div>`;
            
            $(btn_).append(popup)

            setTimeout(function(){
              $(".no_tracking").remove()
            },3000);
            
          }else{
            var link = response.url
            window.open(link, "_blank");
          }
        }).fail(function(e){
          	console.log(e);
        })
    })
  }

  
  if(CEMAIL != "NONE" && window.location.pathname == "/pages/gift-cards"){
    // RETIRAR EMAIL FORCADO DO MIDDLEWARE
    $.get(ENDPOINT,{ action: "accounts_giftcards", store: CHANNEL, email: CEMAIL, token: TOKEN })
    .done(function(data){
      
      var gift_cards_data = data = JSON.parse(data);
      console.log(gift_cards_data)
      if(data.status == 1 && gift_cards_data.data.length > 0){
        $(".page-header__text-wrapper .bubble-count").text(gift_cards_data.data.length)
        var gift_card = gift_cards_data.data

        for (let i = 0; i < gift_card.length; i++) {
          
          var html= `<tr class="account__order-table-item ">
                  <td class="gift_card_id">`+gift_card[i].id+`</td>
                  <td class="gift_card_value">`+gift_card[i].initial_value+`€</td>
                  <td class="gift_card_remaing">`+gift_card[i].balance+`€</td>
                  <td class="gift_card_expire_date">`+gift_card[i].expires_on+`</td>
                </tr>`;

          $(".gift_card_content").append(html)
        }
        
      }else{
        $(".no_gift_cards").removeClass("d-none")
      }
      
    }).fail(function(e){
    
      	console.log(e);
  
    })
  }

  if($(".shopify-section--main-product").length > 0){
    $(".open_size_guide").click(function(){
      if($(window)[0].outerWidth < 768){
        $("#block-template--14836939718721__product-content-sizeguide button").attr("aria-expanded","true");
        $("#block-template--14836939718721__product-content-sizeguide collapsible-content").attr("open");
        $("#block-template--14836939718721__product-content-sizeguide collapsible-content").css("overflow", "visible");
        $('html, body').animate({
          scrollTop: $('#shopify-product-sizeguide').offset().top - 150
        }, 500); 
      }else{
        $(".size_guide_tab").click()
        $('html, body').animate({
          scrollTop: $('.tabs-nav__item.size_guide_tab').offset().top -250
        }, 500);
      }
      

    })
  }

  if($(".product-item").length > 0){
    $(".product-item").each(function(){
      countDown()
    })
  }


  var interval = setInterval(function(){
    if($(".product #countdown").length > 0){
  	  countDown();
      clearInterval(interval);
    }
  },200)
  

  $(".btn-less").click(function() {
    document.getElementsByClassName("additional_description_content")[0].scrollIntoView();
  });
  
  $(".input__field").focusout(function() {
    if($(this).val() != ""){
      $(this).addClass("is-filled");
    }else {
      $(this).removeClass("is-filled");
    }
  });

  if($(window).width() > 768){
    $(".wash_rules_content .rule img").hover(function () {
      $(this).parent().find(".rule_alt").removeClass("d-none");
    }, function () {
      $(this).parent().find(".rule_alt").addClass("d-none");
    });
  }else{
  	$(".wash_rules_content .rule_alt ").removeClass("d-none");
    $(".wash_rules_content .rule_alt ").removeClass("position-absolute");
  }

  if($(".shopify-section--collection-banner").length > 0){
    $('.btn-more').click(function() {
      $(".additional_description_content").removeClass("overflow_text");
      $('.btn-more').addClass('d-none');
      $('.btn-less').removeClass('d-none');
    });

    $('.btn-less').click(function() {
      $(".additional_description_content").addClass("overflow_text");
      $('.btn-less').addClass('d-none');
      $('.btn-more').removeClass('d-none');
    });
  }

  $("#register-customer").submit(function(e){
      $.post( ENDPOINT,
         {
           action:"add_phone_number_on_register", 
           store: CHANNEL, 
           email: $(".emailInput")[0].value, 
           phone: $("#phone_register")[0].value, 
           country: $("#selectIndicative")[0].value
         }
        )
        .done(function(data) {
          console.log(data);
        })
      .fail(function(data){
          $(this).prop("disabled",false)
          alert(data)
      })
    
  });

  $(".newsletter-modal__form").submit(function(e){
      $.post( ENDPOINT,
         {
           action:"add_phone_number_on_register", 
           store: CHANNEL, 
           email: $(".emailInputPopup")[0].value, 
           phone: $("#phone_register_popup")[0].value, 
           country: $("#selectIndicativePopup")[0].value
         }
        )
        .done(function(data) {
          console.log(data);
        })
      .fail(function(data){
          $(this).prop("disabled",false)
          alert(data)
      })
    
  });
 
});

function load_more_products(){
  var loadMoreContainer = document.getElementById('load-more-button-container');

  if (loadMoreContainer) {
    loadMoreContainer.addEventListener('click', function(event) {
      var target = event.target;
      if (target.matches('#load-more-button')) {
        var url = target.getAttribute('data-url');

        // Fetch the next page using AJAX or redirect to the next page URL
        // Handle the response and append the new products to the existing product list

        // Example using AJAX fetch:
        fetch(url)
          .then(function(response) {
            return response.text();
          })
          .then(function(html) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            var newProductList = doc.querySelector('.product-list__inner');
            var hasMoreProducts = doc.querySelector('.product-item');

            if (newProductList) {
              var productContainer = document.querySelector('.product-list__inner');
              productContainer.insertAdjacentHTML('beforeend', newProductList.innerHTML);

              // Add a class to the newly loaded product items
              var newProductItems = productContainer.querySelectorAll('.product-item');
              newProductItems.forEach(function(item) {
                item.classList.add('loaded-item');
              });
            }

            var newLoadMoreContainer = doc.querySelector('#load-more-button-container');
            if (newLoadMoreContainer) {
              loadMoreContainer.innerHTML = newLoadMoreContainer.innerHTML;
            } else {
              loadMoreContainer.parentNode.removeChild(loadMoreContainer);
              var noMoreProductsMessage = document.getElementById('no-more-products-message');
              noMoreProductsMessage.style.display = 'block';
            }

            
          })
          .catch(function(error) {
            console.error('Error loading more products:', error);
          });
      }
    });
  }
}
// Countdown
function countDown(){
  //console.log("== COUNTDOWN ==")
  if(document.getElementById("countdown") != null){
     var endDate = document.getElementById("countdown").getAttribute("data-date")
    var countDownDate = new Date(endDate).getTime();
  
    const currentTime = new Date().getTime();
    const differenceInMilliseconds = countDownDate - currentTime;
  
    const showCountdown = 48 * 60 * 60 * 1000; // 48 hours
  
    if (differenceInMilliseconds < showCountdown && differenceInMilliseconds > 0) {
      console.log("Time difference is less than 48 hours");
      document.getElementById("countdown").classList.remove("d-none");
      document.getElementById("countDownTitle").classList.remove("d-none");
      
      var x = setInterval(function() {
  
        var now = new Date().getTime();
          
        var distance = countDownDate - now;
          
        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);
    
        var countDownDays = `<span>`+days+`</span><label>Day</label>`;
        var countDownHours = `<span>`+hours+`</span><label>Hour</label>`;
        var countDownMinutes = `<span>`+minutes+`</span><label>Minute</label>`;
        var countDownSeconds = `<span>`+seconds+`</span><label>Second</label>`;
    
        document.getElementById("countdown-days").innerHTML = countDownDays;
        document.getElementById("countdown-hours").innerHTML = countDownHours;
        document.getElementById("countdown-minutes").innerHTML = countDownMinutes;
        document.getElementById("countdown-seconds").innerHTML = countDownSeconds;
          
        if (distance < 0) {
          clearInterval(x);
          document.getElementById("countdown").classList.add("d-none")
          
        }
      }, 1000);
    } else{
      console.log("Time difference is more than 48 hours");
      document.getElementById("countdown").remove();
      document.getElementById("countDownTitle").remove();
      
    }
  }

 
  
}


// Estimated delivery date PRODUCT PAGE
if ($(".product-form .delivery_date[data-sku]").length ){

  setTimeout(function(){

     var sku=$(".product-form .delivery_date").attr("data-sku");
    if (sku!=""){
      $.get(ENDPOINT,{ action: "product_phc", store: 6, sku: sku })
      .done(function(data){
        
        var data = JSON.parse(data);
    
        if(data.status == 1){
          
          var service_date=data.data[0].service_date_preorders
          service_date=service_date.replace(" 00:00:00.000","");
          $(".product-form .delivery_date label span").text(service_date);
      
        } else{
          $(".product-form .delivery_date label span").text("undefined");
        }
      }).fail(function(e){
          $(".product-form .delivery_date label span").text("error checking");
      })
    } else {
      console.log("SKU NOT AVAILABLE")
    }
  },3000);
 

}
if ($(".shopify-section--main-product").length > 0 || $(".product-item-form").length > 0) {

    $(".open_size_guide, .size_guide").click(function () {

        if ($(window)[0].outerWidth < 768) {
            // MOBILE: abre o collapsible
            var $btn = $(".collapsible-toggle[aria-controls*='sizeguide']");
            var $wrapper = $btn.closest(".product-tabs__tab-item-wrapper");

            $wrapper.removeAttr("hidden");

            if ($btn.attr("aria-expanded") !== "true") {
                $btn.trigger("click");
            }

            setTimeout(function () {
                $('html, body').animate({
                    scrollTop: $('#shopify-product-sizeguide').offset().top - 150
                }, 300);
            }, 300);

        } else {
            // DESKTOP: clica na tab SIZE GUIDE via aria-controls
            var $tabBtn = $(".tabs-nav__item[aria-controls*='sizeguide']");

            if ($tabBtn.length > 0) {
                $tabBtn.trigger("click");
            } else {
                // Fallback: remove hidden e mostra o conteúdo diretamente
                var $wrapper = $(".collapsible-toggle[aria-controls*='sizeguide']")
                    .closest(".product-tabs__tab-item-wrapper");
                $wrapper.removeAttr("hidden");
            }

            setTimeout(function () {
                $('html, body').animate({
                    scrollTop: $('#shopify-product-sizeguide').offset().top - 150
                }, 300);
            }, 300);
        }
    });

    if ($(window)[0].outerWidth < 768) {
        var $descBtn = $(".collapsible-toggle[aria-controls*='description']");
        if ($descBtn.attr("aria-expanded") === "true") {
            $descBtn.trigger("click");
        }
    }
}
// Estimated delivery date LOOKS
if ($(".product-item-content").length ){

  var skus = [];
  $(".product-item-content").each(function(){
    
      var tsku=$(this).find(".delivery_date").attr("data-sku");
      tsku=tsku.split("#")
      tsku=tsku[0];
      skus.push(tsku)
  })
  $.get(ENDPOINT,{ action: "phc_service_date", store: 6, sku: skus })
  .done(function(data){
    var data = JSON.parse(data);

    if(data.status == 1){
      
      let data_skus = data.data;
      $(".delivery_date").each(function(){
        let delivery_date_sku = $(this).attr("data-sku");
        for (const key in data_skus) {
            if (data_skus.hasOwnProperty(key)) {
                const value = data_skus[key];
                if(key == delivery_date_sku){
                  $(".delivery_date[data-sku='" + key + "'] label span").text(value);
                }
            }
        }
      })
      
      /*
      var service_date=data.data[0].service_date_preorders
      service_date=service_date.replace(" 00:00:00.000","");
      $(".product-item-content .delivery_date label span").text(service_date);
      */
    } else{
      $(".product-item-content .delivery_date label span").text("undefined");
    }
  }).fail(function(e){
      $(".product-item-content .delivery_date label span").text("error checking");
  })

}